import { IconButton } from '@mui/material'
import { ReactComponent as DownloadLogo } from 'assets/analytics_download_logo.svg'
import useExportDeviationReport from 'hook/query/useExportDeviationReport'
import { ShiftOptions } from 'models/ICattlesData'
import { MilkingProcessDeviationType } from 'models/MilkingProcess'
import { COLORS } from 'styles/colors'
import Preloader from 'ui/Preloader'

type DeviationExportButtonProps = {
	startDate: number
	endDate: number
	shift: ShiftOptions[] | 'all'
	parlorId: number[] | 'all'
	milkerId: number[] | 'all'
	deviationType: MilkingProcessDeviationType[] | 'all'
	ordering: string[] | null
}

export const DeviationExportButton = (props: DeviationExportButtonProps) => {
	const {
		startDate,
		endDate,
		shift,
		parlorId,
		milkerId,
		deviationType,
		ordering,
	} = props

	const { isFetchReport, setIsFetchReport } = useExportDeviationReport({
		startDate,
		endDate,
		shiftPeriod: shift,
		parlorId,
		milkerId,
		deviationType,
		ordering,
	})

	return (
		<IconButton
			size='small'
			onClick={() => setIsFetchReport(true)}
			disabled={isFetchReport}
		>
			{isFetchReport ? (
				<Preloader color={COLORS.icon} size={24} />
			) : (
				<DownloadLogo stroke={COLORS.icon} />
			)}
		</IconButton>
	)
}
